enum MessageDirections {
  DIRECTION_NONE = 0,
  DIRECTION_TO_ADMIN = 1,
  DIRECTION_TO_USER = 2
}

export default MessageDirections;
